import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ReviewModal from '../ReviewModal/ReviewModal';
import { homeService } from '../../services/homeService';
import './MemberHistory.css';

function when(value) {
  if (!value) return '';
  return new Date(value).toLocaleString(undefined, {
    month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
  });
}

const MemberHistory = () => {
  const [readings, setReadings] = useState(null);
  const [reviewing, setReviewing] = useState(null);
  const [clearing, setClearing] = useState(false);
  const [note, setNote] = useState('');

  const load = () => {
    homeService.getReadingHistory(0, 5)
      .then((rows) => setReadings(Array.isArray(rows) ? rows : []))
      .catch(() => setReadings([]));
  };

  useEffect(() => {
    load();
  }, []);

  const clear = async () => {
    const confirmed = window.confirm('Delete all of your saved questions and answers? Reviews tied to them are removed too.');
    if (!confirmed) return;
    setClearing(true);
    try {
      await homeService.clearReadingHistory();
      setReadings([]);
      setNote('Saved questions cleared.');
    } catch (err) {
      setNote(err.message || 'Could not clear your saved questions.');
    } finally {
      setClearing(false);
    }
  };

  return (
    <section className="hl-wrap hl-member" aria-labelledby="hl-member-title">
      <div className="hl-member-head">
        <h2 id="hl-member-title">Your recent questions</h2>
        <p>
          <Link to="/account">Settings</Link>
          <Link to="/support">Help</Link>
        </p>
      </div>
      {note && <p className="hl-member-note">{note}</p>}
      {readings === null && <p className="hl-member-note">Loading your questions…</p>}
      {readings && readings.length === 0 && (
        <p className="hl-member-note">No saved answers yet. Ask a question above and it will be kept here.</p>
      )}
      {readings && readings.length > 0 && (
        <ul className="hl-member-list">
          {readings.map((reading) => (
            <li key={reading.id}>
              <div>
                <strong>{reading.question}</strong>
                <time>{when(reading.created_at)}</time>
                {reading.answer && <p>{reading.answer.length > 280 ? `${reading.answer.slice(0, 280)}…` : reading.answer}</p>}
              </div>
              {reading.has_review ? (
                <span className="hl-member-done">Reviewed</span>
              ) : (
                <button type="button" onClick={() => setReviewing(reading.id)}>Review</button>
              )}
            </li>
          ))}
        </ul>
      )}
      {readings && readings.length > 0 && (
        <button type="button" className="hl-member-clear" onClick={clear} disabled={clearing}>
          {clearing ? 'Clearing…' : 'Clear questions'}
        </button>
      )}
      <p className="hl-member-note">
        Saving new questions is controlled in <Link to="/account">Settings</Link>.
      </p>
      {reviewing && (
        <ReviewModal
          textReadingId={reviewing}
          onClose={() => setReviewing(null)}
          onSubmitted={() => {
            setReviewing(null);
            load();
          }}
        />
      )}
    </section>
  );
};

export default MemberHistory;
